import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap, Circle } from "react-leaflet";
import L from "leaflet";
import { Link } from "react-router-dom";
import { gbp } from "@/lib/api";

// Fix leaflet default icon paths
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const customIcon = L.divIcon({
  className: "fm-marker",
  html: `<div style="background:#E05915;color:white;padding:6px 10px;border-radius:9999px;font-weight:600;font-size:12px;box-shadow:0 4px 10px rgba(0,0,0,0.18);border:2px solid white;">£</div>`,
  iconSize: [40, 30],
  iconAnchor: [20, 30],
});

function FitBounds({ items, origin }) {
  const map = useMap();
  useEffect(() => {
    const points = items
      .filter((i) => i.retailer?.lat && i.retailer?.lng)
      .map((i) => [i.retailer.lat, i.retailer.lng]);
    if (origin?.lat && origin?.lng) points.push([origin.lat, origin.lng]);
    if (points.length >= 2) {
      map.fitBounds(points, { padding: [40, 40] });
    } else if (points.length === 1) {
      map.setView(points[0], 12);
    }
  }, [items, origin, map]);
  return null;
}

export default function ResultsMap({ items, origin }) {
  const center = origin?.lat && origin?.lng ? [origin.lat, origin.lng] : [53.4808, -2.2426];
  return (
    <div className="rounded-xl overflow-hidden border border-slate-200 h-[520px] relative" data-testid="results-map">
      <div className="absolute top-3 right-3 z-[400] bg-white/95 backdrop-blur border border-slate-200 rounded-full px-3 py-1 text-xs text-slate-600 shadow-sm">
        Pins are approximate · exact address after reservation
      </div>
      <MapContainer center={center} zoom={11} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        />
        {origin?.lat && origin?.lng && (
          <Circle
            center={[origin.lat, origin.lng]}
            radius={2500}
            pathOptions={{ color: "#2A5A3B", fillColor: "#2A5A3B", fillOpacity: 0.1, weight: 1 }}
          />
        )}
        {items.map((l) =>
          l.retailer?.lat && l.retailer?.lng ? (
            <Marker
              key={l.id}
              position={[l.retailer.lat, l.retailer.lng]}
              icon={customIcon}
            >
              <Popup>
                <div className="text-sm">
                  <div className="font-semibold capitalize">
                    {l.colour} {l.flooring_type.replace("_", " ")}
                  </div>
                  <div>{l.width_m}m × {l.length_m}m · {gbp(l.price_gbp)}</div>
                  <div className="text-slate-500">Verified retailer · {l.retailer.locality}</div>
                  <Link to={`/listing/${l.id}`} className="text-[#E05915] font-semibold">
                    View listing →
                  </Link>
                </div>
              </Popup>
            </Marker>
          ) : null
        )}
        <FitBounds items={items} origin={origin} />
      </MapContainer>
    </div>
  );
}
